(function ($) {
	"use strict";

	$(function () {
		$(".employee-dropdown .sub-menu a").click(function () {
			var subMenu = $(this).parents(".sub-menu");
			subMenu.toggle();
		});
	});
})(jQuery);

